import { module } from 'angular';
import { react2angular } from 'react2angular';
import { SearchResult } from './SearchResult';

export const SEARCH_RESULT_COMPONENT = 'spinnaker.core.search.infrastructure.searchResult.component';
module(SEARCH_RESULT_COMPONENT, []).component('searchResult', react2angular(SearchResult, ['displayName', 'account']));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/search/infrastructure/searchResult.component.ts